<div class="page-header">
    <div class="page-header-text" *ngIf="isGracePayment">We found this policy:</div>
    <div class="page-header-text" *ngIf="!isGracePayment && isPendingPolicy">We found this pending policy:</div>
    <div class="page-header-text" *ngIf="!isGracePayment && !isPendingPolicy">We found this policy:</div>
</div>

<div class="page-body">
    <div class="body-sub-heading" data-testid="policyFoundProductType">{{userInfo?.productType}} {{userInfo?.policyNumber}}</div>
    <div class="body-text" data-testid="policyFoundPrimaryInsuredName"><span class="body-bold">Primary insured:&nbsp;</span>{{userInfo?.primaryInsuredName}}</div>
    <div class="body-text">If that's the correct policy, then let's choose your payment amount. If that's <span
            class="body-bold">not</span>&nbsp;correct,
        call our Life Insurance Solutions Center at&nbsp;<span class="text-phone">1-800-848-6331.</span>
    </div>
</div>

<div class="page-footer">
    <bolt-button-bar class="footer-button-bar">
        <bolt-button slot="cancel" data-testid="policyFoundCancelButton" (click)="onCancel()">Cancel</bolt-button>
        <bolt-button slot="back" data-testid="policyFoundBackButton" (click)="onBack()">Back</bolt-button>
        <bolt-button slot="forward" type="primary" data-testid="policyFoundContinueButton" (click)="onNext()">Continue to payment amount</bolt-button>
    </bolt-button-bar>
</div>